<template>
	<Paginate
		:value="page"
		@input="onChange"

		:pageCount="pageCount"
		:pageRange="pageRange"
		:marginPages="marginPages"

		:firstLastButton="firstLastButtons"
		:hidePrevNext="hidePrevNext"

		:firstButtonText="first"
		:prevText="prev"
		:breakViewText="ellipsis"
		:nextText="next"
		:lastButtonText="last"

		containerClass="paginator"
		pageClass="paginator__page"
		pageLinkClass="paginator__link"
		prevLinkClass="paginator__link"
		breakViewLinkClass="paginator__link"
		nextLinkClass="paginator__link"
		prevClass="paginator__prev"
		breakViewClass="paginator__ellipsis"
		nextClass="paginator__next"/>

		<!-- :firstLastButton="firstLastButtons"
			prevClass="paginator__prev"
		breakViewClass="paginator__ellipsis"
		nextClass="paginator__next" -->
</template>

<script>
	import VueTypes from "vue-types"
	import Paginate from "vuejs-paginate"

	const svgWidth = 25;

	const nullString = VueTypes.oneOfType([
		VueTypes.string,
		VueTypes.oneOf([ null ]),
	]).def(null);

	const requiredNumber = VueTypes.number.isRequired;

	export default {
		props: {
			pageCount: requiredNumber,
			page: requiredNumber,
			pageRange: VueTypes.number.def(3),
			marginPages: VueTypes.number.def(1),

			firstLastButtons: VueTypes.bool.def(false),
			hidePrevNext: VueTypes.bool.def(false),

			prevText: nullString,
			breakText: nullString,
			nextText: nullString,
			firstButtonText: nullString,
			lastButtonText: nullString,
		},
		components: {
			Paginate,
		},
		computed: {
			prev(){
				return this.prevText || `
					<svg width="${svgWidth}" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M14 5L9 10L14 15L13 17L6 10L13 3L14 5Z" fill="black"/>
					</svg>

				`;
			},
			next(){
				return this.nextText || `
					<svg width="${svgWidth}" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M6 15L11 10L6 5L7 3L14 10L7 17L6 15Z" fill="black"/>
					</svg>

				`;
			},
			ellipsis(){
				return this.breakText || "...";
			},
			first(){
				return this.firstButtonText || `
					<svg width="${svgWidth}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M4 6H6V18H4V6ZM14.293 5.293L7.586 12L14.293 18.707L15.707 17.293L11.414 13H20V11H11.414L15.707 6.707L14.293 5.293Z" fill="black"/>
					</svg>

				`;
			},
			last(){
				return this.lastButtonText || `
					<svg width="${svgWidth}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M18 6H20V18H18V6ZM4 13H12.586L8.293 17.293L9.707 18.707L16.414 12L9.707 5.293L8.293 6.707L12.586 11H4V13Z" fill="black"/>
					</svg>

				`;
			},
		},
		methods: {
			onChange(page){
				this.$emit("pageChange", page);
			}
		},
	}
</script>

<style lang="scss">
	@use "~@scss/components/PaginationIndicator" as *;
</style>